export default __webpack_public_path__ + "static/media/star_pink.f4e285eb.svg";